function normalizeHost(host: string): string {
  return (host || '').trim().toLowerCase();
}

function normalizeHostEntry(value: string): string {
  const raw = (value || '').trim();
  if (!raw) return '';

  // Разрешаем задавать как URL, так и hostname:
  // - "https://compare2.domain.com/path" -> "compare2.domain.com"
  // - "compare2.domain.com" -> "compare2.domain.com"
  try {
    if (/^https?:\/\//i.test(raw)) {
      return normalizeHost(new URL(raw).hostname);
    }
  } catch {
    // no-op, fallback to manual parsing below
  }

  const withoutPath = raw.split('/')[0];
  const withoutPort = withoutPath.split(':')[0];
  return normalizeHost(withoutPort);
}

function parseDomainsList(value: string | undefined): string[] {
  if (!value) return [];
  return value
    .split(',')
    .map((s) => normalizeHostEntry(s))
    .filter(Boolean);
}

/**
 * Определяет, нужно ли показывать black-лендинг по текущему домену.
 *
 * Настройка через env:
 * - VITE_BLACK_DOMAINS="compare2.example.com,compare2.staging.example.com"
 *   (можно также URL: "https://compare2.example.com")
 *
 * Если переменная не задана, применяется fallback под текущую задачу:
 * - true, если первый label хоста равен "compare2" (compare2.example.com)
 */
export function isBlackDomain(hostname = window.location.hostname): boolean {
  const host = normalizeHost(hostname);
  const configured = parseDomainsList(import.meta.env.VITE_BLACK_DOMAINS);

  if (configured.length > 0) {
    return configured.includes(host);
  }

  const firstLabel = host.split('.')[0];
  return firstLabel === 'compare2';
}
